import { Flex, NavLink as MantineNavLink, Text } from '@mantine/core';
import classes from './DevTools.module.css';
import { Icon } from '../../../../lib/components';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFlags } from '../../../contexts/FlagsContext';
import { useUser } from '../../../hooks';

type Props = {
  children: React.ReactNode;
};

const DevToolsLayout = ({ children }: Props) => {
  const { t } = useTranslation();
  const { WEBHOOKS } = useFlags();
  const { data: user } = useUser();
  const canManageWebhooks = user?.entitlements?.canManageWebhooks;
  const location = useLocation();

  const sidebarLinks: {
    label: string;
    to: string;
    visible: boolean;
  }[] = [
    {
      label: t('devTools.apiAccess.title'),
      to: 'api-access',
      visible: true,
    },
    {
      label: t('devTools.webhooks.title'),
      to: 'webhooks',
      visible: !!WEBHOOKS && !!canManageWebhooks,
    },
  ];

  return (
    <Flex
      className={classes.rootWrapper}
      direction={{
        base: 'column',
        md: 'row',
      }}
    >
      <div>
        <nav className={classes.navigation}>
          <MantineNavLink
            label={t('devTools.backButton')}
            component={Link}
            to="/admin"
            leftSection={<Icon icon="chevron-left" />}
          />

          <Text fw="bold" size="md" mt="lg" ml="xs" mb="md">
            {t('devTools.title')}
          </Text>

          {sidebarLinks
            .filter((link) => link.visible)
            .map((link) => (
              <MantineNavLink
                component={Link}
                to={link.to}
                label={link.label}
                active={location.pathname.includes(link.to)}
                c="white"
              />
            ))}
        </nav>
      </div>

      <section className={classes.devToolsContent}>{children}</section>
    </Flex>
  );
};

export default DevToolsLayout;
